const NBSP = " ";
/** Word joiner: forbids a line break without showing anything. */
const WJ = "⁠";

const UNITS = [
  "Wochen", "Woche", "Monaten", "Monate", "Monat", "Tagen", "Tage", "Werktagen", "Werktage",
  "Arbeitstagen", "Arbeitstage", "Stunden", "Minuten", "Sekunden", "Jahren", "Jahre", "Min", "h",
  "weeks", "week", "months", "month", "working days", "days", "hours", "minutes", "seconds", "years",
  "uger", "uge", "måneder", "måned", "arbejdsdage", "dage", "timer", "minutter", "sekunder", "år",
  "km", "%",
].join("|");

const CURRENCY = /(€|CHF|DKK|EUR|§|Art\.|Abs\.|Nr\.)\s(?=\d)/g;
const RANGE = /(\d)–(\d)/g;
const NUMBER_UNIT = new RegExp(`(\\d)\\s(?=(?:${UNITS})(?![\\p{L}]))`, "gu");
/** "Woche 1", "Phase 2", "Schritt 3": the counter stays with its word. */
const UNIT_NUMBER = /\b(Woche|Tag|Phase|Schritt|Stufe|Week|Day|Step|Uge|Dag|Fase|Trin)\s(?=\d)/g;
/** "u. a.", "z. B.", "d. h.", "o. ä." never break in the middle. */
const ABBREVIATION = /\b(u|z|d|o)\.\s(a|B|h|ä)\./g;
/** "ca. €281", "(ca. 5 Tage)": "ca." stays with its number. */
const CIRCA = /\bca\.\s(?=[€\d])/g;

/**
 * Keeps numbers with their currency or unit, and ranges in one piece, so a
 * line never breaks inside "€150–300", "6 Wochen", "Woche 1" or "§ 1309".
 * Only the text between tags changes; tags and attributes are left alone.
 */
export function keepTogether(html: string): string {
  return html
    .split(/(<[^>]+>)/)
    .map((part) =>
      part.startsWith("<")
        ? part
        : part
            .replace(CURRENCY, `$1${NBSP}`)
            .replace(RANGE, `$1${WJ}–${WJ}$2`)
            .replace(NUMBER_UNIT, `$1${NBSP}`)
            .replace(UNIT_NUMBER, `$1${NBSP}`)
            .replace(ABBREVIATION, `$1.${NBSP}$2.`)
            .replace(CIRCA, `ca.${NBSP}`),
    )
    .join("");
}

const SHY = "­";

/**
 * Headings are not hyphenated automatically: the browser split "Ös-terreich"
 * and "Däne-mark". The few compounds that are wider than a phone line get a
 * soft hyphen at their joint instead, so they break only there, and only when
 * they must.
 */
const COMPOUNDS: [RegExp, string][] = [
  [/Ledigkeitsbescheinigung/g, `Ledigkeits${SHY}bescheinigung`],
  [/Ehefähigkeitszeugnis/g, `Ehefähigkeits${SHY}zeugnis`],
  [/Familiennachzug/g, `Familien${SHY}nachzug`],
  [/Familiesammenføring/g, `Familie${SHY}sammenføring`],
  [/Civilstandsattest/g, `Civilstands${SHY}attest`],
  [/Namensänderung/g, `Namens${SHY}änderung`],
  [/Hochzeitsdokumente/g, `Hochzeits${SHY}dokumente`],
  [/Heiratsurkunde/g, `Heirats${SHY}urkunde`],
  [/Eheschliessung/g, `Ehe${SHY}schliessung`],
];

export function softHyphenate(text: string): string {
  return COMPOUNDS.reduce((acc, [re, withShy]) => acc.replace(re, withShy), text);
}
